import React, { useContext } from "react";
import { LegacyCard as Card, Collapsible, Layout, Text, TextField, Box } from "@shopify/polaris";

// hoc
import { withErrorBoundary, withFeature } from "lib/hoc";

// constants/helpers
import constant from "lib/constant/constant";
import { baseHelper } from "lib/helpers";

// context
import { PrivateContext } from "lib/context";
import { BrandingContext } from "app/setup/modules/operator/features/branding/context/context";

const WelcomeDescription = () => {
  const { setOnboarding, onboarding, setIsSubmitEnable, welcomeDescription } = useContext(BrandingContext);
  const { CHARACTER_COUNT, DEFAULT_WELCOME_DESCRIPTION } = constant;

  const { cms = () => {}, currentUser } = useContext(PrivateContext);
  const { brand } = currentUser || {};
  const { welcome, updatedAt: brandUpdatedAt = "" } = brand || {};
  const { description: welcomeDesc } = welcome || {};
  const { updatedAt = "" } = welcomeDesc || {};

  const lastUpdated = updatedAt || brandUpdatedAt;

  const onChangeAction = (value) => {
    // Clamp and store
    const trimmed = (value || "").slice(0, CHARACTER_COUNT);
    setOnboarding({ ...onboarding, welcomeDescription: trimmed });
    setIsSubmitEnable(true);
  };

  return (
    <Collapsible open>
      <Layout.AnnotatedSection
        title={cms("section.welcomeDescription.title")}
        description={cms("section.welcomeDescription.description")}
      >
        <Card
          title={cms("section.welcomeDescription.card.title")}
          actions={
            welcomeDescription !== DEFAULT_WELCOME_DESCRIPTION
              ? [
                  {
                    content: cms("label.reset"),
                    onAction: () => {
                      setOnboarding({ ...onboarding, welcomeDescription: DEFAULT_WELCOME_DESCRIPTION });
                      setIsSubmitEnable(true);
                    },
                  },
                ]
              : undefined
          }
        >
          <Card.Section>
            <Box paddingBlockEnd="3">
              <Text as="p" tone="subdued">
                {cms("common.label.lastUpdatedAt")}: {baseHelper.lastUpdateDate(lastUpdated)}
              </Text>
            </Box>

            <div className="h200-textfield">
              {/* Make the field taller: multiline rows (e.g., 8) + built-in counter */}
              <TextField value={welcomeDescription} onChange={onChangeAction} multiline={4} showCharacterCount />
            </div>
          </Card.Section>
        </Card>
      </Layout.AnnotatedSection>
    </Collapsible>
  );
};

export default withFeature(withErrorBoundary(WelcomeDescription), {
  feature: constant.STANDARD_BRANDING,
});
